/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var ModalService = /** @class */ (function () {
            function ModalService($uibModal) {
                this.$uibModal = $uibModal;
                this.modal = $uibModal;
            }
            /**
             * Opens the modal instance with default value for options allowing the modal to set the controller, template, size (default large) and any resolve params
             * @param modalFolderName - The modal folder name wheree the template.html file resides
             * @param controller - The Controller name used for angular injection.
             * @param resolve - Any parameters that need to be resolved during injection.
             * @param size - The sizes supported by the modal service UI.
             * @returns {} - The results promise of the modal once the user performs their tasks.
             */
            ModalService.prototype.open = function (modalFolderName, controller, resolve, size) {
                var options = {
                    backdrop: false,
                    controller: controller,
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: resolve || {},
                    size: null,
                    templateUrl: "app/modals/" + modalFolderName + "/template.html"
                };
                if (!size)
                    size = ModalSize.Large;
                switch (size) {
                    case ModalSize.Small:
                        options.size = 'sm';
                        break;
                    case ModalSize.Medium:
                        options.size = 'md';
                        break;
                    default:
                        options.size = 'lg';
                        break;
                }
                return this.modal.open(options).result;
            };
            ModalService.prototype.confirmModal = function (modalOptions) {
                var resolve = {
                    modalOptions: function () { return modalOptions; }
                };
                return this.open('confirm', app.Modals.ConfirmModalController, resolve, modalOptions.modalSize || ModalSize.Small);
            };
            ModalService.prototype.openEditReportConfigModal = function (modalOptions) {
                var resolve = {
                    modalOptions: function () { return modalOptions; }
                };
                return this.open('edit-report-configuration', app.Modals.EditReportConfigModalController, resolve, modalOptions.modalSize || ModalSize.Small);
            };
            ModalService.prototype.openMultipointReportConfigModal = function (modalOptions) {
                var resolve = {
                    modalOptions: function () { return modalOptions; }
                };
                return this.open('multipoint-report-configuration', app.Modals.MultipointReportConfigModalController, resolve, modalOptions.modalSize || ModalSize.Medium);
            };
            ModalService.inject = ['$uibModal'];
            return ModalService;
        }());
        Services.ModalService = ModalService;
        angular.module('app.Services')
            .service('modalService', ModalService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
